var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContacts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.234,
    height: 52.234,
    viewBox: "0 0 52.234 52.234",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(-51.2 -51.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M96.905,51.2H65.564a6.537,6.537,0,0,0-6.529,6.529v6.529H52.506a1.306,1.306,0,1,0,0,2.612h6.529v5.223H52.506a1.306,1.306,0,1,0,0,2.612h6.529v5.223H52.506a1.306,1.306,0,1,0,0,2.612h6.529v5.223H52.506a1.306,1.306,0,1,0,0,2.612h6.529v6.529a6.537,6.537,0,0,0,6.529,6.529H96.905a6.537,6.537,0,0,0,6.529-6.529V57.729A6.537,6.537,0,0,0,96.905,51.2Zm3.918,45.705a3.922,3.922,0,0,1-3.918,3.918H65.564a3.922,3.922,0,0,1-3.918-3.918V57.729a3.922,3.922,0,0,1,3.918-3.918H96.905a3.922,3.922,0,0,1,3.918,3.918Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M210.716,164.919a6.529,6.529,0,1,0-8.807,0,11.757,11.757,0,0,0-7.349,10.88,1.306,1.306,0,0,0,2.612,0,9.141,9.141,0,1,1,18.282,0,1.306,1.306,0,0,0,2.612,0A11.757,11.757,0,0,0,210.716,164.919Zm-8.321-4.79a3.918,3.918,0,1,1,3.918,3.918A3.922,3.922,0,0,1,202.4,160.129Z",
    transform: "translate(-125.078 -89.341)",
    fill: "#444"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.a59bcd9c20f6ce76ed2c95d99a6c84af.svg";
export { ForwardRef as ReactComponent };